import React from "react";
import PropTypes from "prop-types";

import Section from "@components/ContentEditorView/Section";
import Medium from "@components/ContentEditorView/Medium";
import YouTube from "@components/ContentEditorView/YouTube";
import TextImage from "@components/ContentEditorView/TextImage";
import Grid from "@components/ContentEditorView/Grid";
import Column from "@components/ContentEditorView/Column";
import Image from "@components/ContentEditorView/Image";
import HtmlEmbed from "@components/ContentEditorView/HtmlEmbed";
import StaticBlock from "@components/ContentEditorView/StaticBlock";
import FormBlock from "@components/ContentEditorView/FormBlock";
import HiddenInput from "@components/ContentEditorView/HiddenInput";
import TextInput from "@components/ContentEditorView/TextInput";
import SubmitInput from "@components/ContentEditorView/SubmitInput";
import TextareaInput from "@components/ContentEditorView/TextareaInput";
import CheckboxInput from "@components/ContentEditorView/CheckboxInput";
import RadioInput from "@components/ContentEditorView/RadioInput";
import RadioGroup from "@components/ContentEditorView/RadioGroup";
import ModalBlock from "@components/ContentEditorView/ModalBlock";
import GalleryBlock from "@components/ContentEditorView/GalleryBlock";
import ProductsBlock from "@components/ContentEditorView/ProductsBlock";
import Image360 from "@components/ContentEditorView/Image360";

const componentMap = {
  section: Section,
  checkboxInput: CheckboxInput,
  column: Column,
  form: FormBlock,
  gallery: GalleryBlock,
  grid: Grid,
  hiddenInput: HiddenInput,
  htmlEmbed: HtmlEmbed,
  image: Image,
  imageSlider: Image360,
  medium: Medium,
  modal: ModalBlock,
  products: ProductsBlock,
  radioGroup: RadioGroup,
  radioInput: RadioInput,
  textareaInput: TextareaInput,
  staticBlock: StaticBlock,
  submitInput: SubmitInput,
  textInput: TextInput,
  textimage: TextImage,
  youtube: YouTube,
};

const parseContentTree = (item, index) => {
  const Component = componentMap[item.type];

  const componentProps = {
    ...item.content,
    children: [...item.blocks],
  };

  return Component && <Component key={index} {...componentProps} />;
};

const ContentEditorComponent = ({ content }) => {
  if (Array.isArray(content) && content.length > 0) {
    return (
      <>
        {content
          // Show only items with type defined
          .filter((item) => item.type)
          // Parse content
          .map((item, index) => parseContentTree(item, index))}
      </>
    );
  }

  // No data provided
  return null;
};

ContentEditorComponent.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ContentEditorComponent;
